import { request } from './newRequest'


export function checkCoursePermission(id) {
    return request({
        url: `/study/checkCoursePermission?courseId=${id}`,
        method: 'get',
    })
}

export function newLiveStatus(data) {
    return request({
        url: `/educationH5Server/room/newLiveStatus?Action=${data.Action}&ClassNo=${data.ClassNo}&projectId=${data.projectId}&Operator=${data.Operator}&totalusernum=${data.totalusernum}`,
        method: 'get',
    })
}

